/* Copyright IBM Corp. 2018 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpResourceOptions } from './../../../api';
import { WchService } from './../wch.service';

@Injectable({ providedIn: 'root' })
export class WchHttpService {

    /**
     * Fetches a JSON resource and keeps this live based on the given or the default options
     *
     * @param aUrl the URL to fetch, this can be a relative URL in which case it applies to the correct base API URL
     * @return an observable with the content
     */
    getJsonResource: <T>(aUrl: string, aOptions?: HttpResourceOptions) => Observable<T>;

    /**
     * Fetches a string resource and keeps this live based on the given or the default options
     *
     * @param aUrl the URL to fetch, this can be a relative URL in which case it applies to the correct base API URL
     * @return an observable with the content
     */
    getTextResource: (aUrl: string, aOptions?: HttpResourceOptions) => Observable<string>;

    constructor(aWchService: WchService) {
        // just dispatch
        this.getJsonResource = aWchService.getJsonResource;
        this.getTextResource = aWchService.getTextResource;
    }
}
